<template>
	<div
		role="button"
		:tabindex="tabindex"
		@click="onClick"
		@keydown.enter="onHandleKeydown"
		@keydown.space="onHandleKeydown"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'KkAccessibleButton',
	props: {
		tabindex: {
			type: [Number, String],
			default: 0,
		},
	},
	methods: {
		onClick() {
			this.$emit('click');
		},
		onHandleKeydown(event) {
			event.preventDefault();
			this.onClick();
		},
	},
}
</script>
